import React, {useState, useEffect} from "react";
import {Button, Col, Form, Row, Select, Space, message} from "antd";
import {EditOutlined, CheckOutlined, CloseOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";
import {courierEmploymentTypes} from "constants/constants";

const CourierSummaryEmploymentType = ({
    employmentType: initialEmploymentType,
    selectedEmploymentType,
    onSave
}) => {
    const {t} = useTranslation();
    const [isEditing, setIsEditing] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const stores = useStore();

    const resolvedValue =
        selectedEmploymentType !== undefined ? selectedEmploymentType : initialEmploymentType;

    useEffect(() => {
        form.setFieldsValue({
            employmentType: resolvedValue ?? undefined
        });
    }, [resolvedValue]);

    const displayLabel = () => {
        const item = courierEmploymentTypes.find(x => x.value === resolvedValue);
        return item?.name ?? "-";
    };

    const handleEdit = () => {
        form.setFieldsValue({employmentType: resolvedValue ?? undefined});
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        form.resetFields();
    };

    const handleSubmit = async values => {
        try {
            setLoading(true);
            await onSave({employmentType: values.employmentType ?? null});
            setIsEditing(false);
        } catch (error) {
            console.error("Error updating employment type:", error);
            message.error(
                error.response?.data?.message || t("Çalışma şekli güncellenirken bir hata oluştu")
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            form={form}
            onFinish={handleSubmit}
            initialValues={{employmentType: resolvedValue ?? undefined}}
        >
            <Row gutter={[8, 8]} align="middle">
                <Col flex="auto">
                    {isEditing ? (
                        <Form.Item name="employmentType" style={{marginBottom: 0}}>
                            <Select
                                allowClear
                                placeholder="Seçiniz"
                                style={{width: "100%", maxWidth: 220}}
                            >
                                {courierEmploymentTypes.map(option => (
                                    <Select.Option key={option.value} value={option.value}>
                                        {option.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    ) : (
                        <div style={{padding: "5px 0"}}>{displayLabel()}</div>
                    )}
                </Col>
                <Col>
                    {stores.meStore.checkRole("updateCourier") &&
                        stores.meStore.checkPermission("couriers.edit") &&
                        (isEditing ? (
                            <Space>
                                <Button
                                    type="text"
                                    icon={<CheckOutlined />}
                                    htmlType="submit"
                                    loading={loading}
                                />
                                <Button
                                    type="text"
                                    icon={<CloseOutlined />}
                                    onClick={handleCancel}
                                    disabled={loading}
                                />
                            </Space>
                        ) : (
                            <Button type="text" icon={<EditOutlined />} onClick={handleEdit} />
                        ))}
                </Col>
            </Row>
        </Form>
    );
};

export default CourierSummaryEmploymentType;
